import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  container: {alignSelf: 'center'},
});

export default styles;
